import React from 'react';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useTranslation } from 'react-i18next';
import {
  calendarSurfaceSx,
  getDateAdapterLocale,
  getDatePickerLocaleText,
} from './datePickerStyles';

const SalovareDateCalendar = ({
  value,
  onChange,
  views = ['year', 'month', 'day'],
  openTo = 'day',
  disableFuture = false,
  disablePast = false,
  minDate,
  maxDate,
  slots,
  slotProps,
  sx,
  ...calendarProps
}) => {
  const { t, i18n } = useTranslation();
  const adapterLocale = getDateAdapterLocale(i18n.language);

  return (
    <LocalizationProvider
      adapterLocale={adapterLocale}
      dateAdapter={AdapterDateFns}
      localeText={getDatePickerLocaleText(t)}
    >
      <DateCalendar
        value={value}
        onChange={onChange}
        views={views}
        openTo={openTo}
        disableFuture={disableFuture}
        disablePast={disablePast}
        minDate={minDate}
        maxDate={maxDate}
        slots={slots}
        slotProps={slotProps}
        sx={{
          width: '100%',
          maxWidth: '100%',
          m: 0,
          ...calendarSurfaceSx,
          ...sx,
        }}
        {...calendarProps}
      />
    </LocalizationProvider>
  );
};

export default SalovareDateCalendar;
